import { IntlShape } from 'react-intl';
import {
  formatTranslation,
  projectInvolvementTypeLabelKey,
  userRoleLabelKey,
} from 'intl';
import { DocumentationTranslationKeys, FiltersTranslationKeys, InspectionTranslationKeys } from 'intl/keys';
import { DocumentState, IssueState } from '../types';
import { UserRole } from 'shared/types/userRole';
import { InvolvementType, involvementTypes } from 'shared/domain/company/types/model';
export const getDocumentStateValueOptions = (
  intl: IntlShape
): { value: DocumentState; label: string }[] => [
  {
    value: DocumentState.published,
    label: formatTranslation(intl, DocumentationTranslationKeys.statePublished),
  },
  {
    value: DocumentState.archived,
    label: formatTranslation(intl, DocumentationTranslationKeys.stateWithdrawn),
  },
];

export const getInspectionStateValueOptions = (
  intl: IntlShape
): { value: DocumentState; label: string }[] => [
  {
    value: DocumentState.published,
    label: formatTranslation(intl, InspectionTranslationKeys.stateActiveValue),
  },
  {
    value: DocumentState.archived,
    label: formatTranslation(intl, InspectionTranslationKeys.stateArchivedValue),
  },
];

export const getIssueStateFilterValueOptions = (
  intl: IntlShape
): { value: IssueState; label: string }[] => [
  {
    value: IssueState.published,
    label: formatTranslation(intl, FiltersTranslationKeys.activeIssues),
  },
  {
    value: IssueState.archived,
    label: formatTranslation(intl, FiltersTranslationKeys.removedIssues),
  },
];

export const getProjectInvolvementTypeValueOptions = (
  intl: IntlShape
): Array<{ value: InvolvementType; label: string }> =>
  involvementTypes.map((value) => ({
    value,
    label: formatTranslation(intl, projectInvolvementTypeLabelKey(value)),
  }));

export const getUserRoleValueOptions = (
  intl: IntlShape
): Array<{ value: UserRole; label: string }> => [
  {
    value: UserRole.organizationAdmin,
    label: formatTranslation(intl, userRoleLabelKey(UserRole.organizationAdmin)),
  },
  {
    value: UserRole.projectAdmin,
    label: formatTranslation(intl, userRoleLabelKey(UserRole.projectAdmin)),
  },
  {
    value: UserRole.manager,
    label: formatTranslation(intl, userRoleLabelKey(UserRole.manager)),
  },
  {
    value: UserRole.viewer,
    label: formatTranslation(intl, userRoleLabelKey(UserRole.viewer)),
  },
  {
    value: UserRole.standard,
    label: formatTranslation(intl, userRoleLabelKey(UserRole.standard)),
  },
  {
    value: UserRole.visible_no_access,
    label: formatTranslation(
      intl,
      userRoleLabelKey(UserRole.visible_no_access)
    ),
  },
];